var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M21.992 25a1.5 1.5 0 1 1-2.999.001 1.5 1.5 0 0 1 2.999 0ZM15.764 21.285c2.71-2.929 6.785-2.971 9.526-.013M9.33 14.16c12.178-10.72 22.323 0 22.323 0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M12.339 17.607c4.373-4.724 11.984-4.777 16.37-.04"
}))));
export default SvgWifi;